<div class="col-md-8">
    <suite-rfb-expanded-menu></suite-rfb-expanded-menu>
</div>